import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { UspCard } from '@features/product/product.models';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '@shared/image/image/image.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { GtmService } from '@core/services/gtm/gtm.service';

@Component({
    selector: 'app-product-usp-card',
    templateUrl: './product-usp-card.component.html',
    styleUrls: ['./product-usp-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, ImageComponent, RouterLink, NgTemplateOutlet]
})
export class ProductUspCardComponent {
    private readonly gtmService: GtmService = inject(GtmService);

    public readonly title = input<string>();
    public readonly data = input.required<UspCard>();
    public readonly index = input.required<number>();

    uspCardClick = (data: UspCard): void => {
        this.gtmService.trackingEvents.trackPromotionClick({
            creative_name: 'USP Spot - PLP',
            creative_slot: this.title(),
            promotion_id: '',
            promotion_name: data.title,
            index: this.index()
        });
    };
}
